import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

// Admin (and its restricted "support" sub-role) has its own dedicated login
// route, separate from the user/rider login page.
const loginPathFor = (allowedRoles) =>
  allowedRoles && allowedRoles.every((r) => r === "admin" || r === "support") ? "/admin/login" : "/login";

// allowedRoles: array of roles permitted, e.g. ["user"], ["rider"], ["admin"]
export default function ProtectedRoute({ allowedRoles, children }) {
  const { account } = useAuth();
  const loginPath = loginPathFor(allowedRoles);
  if (!account) return <Navigate to={loginPath} replace />;
  if (allowedRoles && !allowedRoles.includes(account.role)) {
    return <Navigate to={loginPath} replace />;
  }
  return children;
}
